import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useRowNavigation(basePath: string) {
  const navigate = useNavigate();

  return useCallback(
    (id: string, event: React.MouseEvent | React.KeyboardEvent) => {
      const url = `${basePath}/${id}`;
      if (event.ctrlKey || event.metaKey) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        navigate(url);
      }
    },
    [basePath, navigate]
  );
}

export default useRowNavigation;
